import { NotifyHelper } from "../../../helpers/toast";
import { objConCbnvDefine } from "../../action-types/con-cbnv/IConCbnvActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const conCbnvActions = {
    ...generateActions(objConCbnvDefine, "CON_CBNV"),
    ...generateActionForKey(objConCbnvDefine, "CON_CBNV",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objConCbnvDefine, "CON_CBNV",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objConCbnvDefine, "CON_CBNV",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objConCbnvDefine, "CON_CBNV",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objConCbnvDefine, "CON_CBNV",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
